import React from 'react';
import {Glob as G} from "../../libs/Glob.mjs";
import {Label} from "reactstrap";

const prefix = 'AutoField';

/** @typedef {import("../helperLibs/autoFormFieldHelper").AutoFormFieldHelperObject } */

const Snippet = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = typeof props.node !== 'object' ? {text: typeof props.node!== 'undefined' ? String(props.node) : ''} : props.node;
		this.state.node = (this.state.node || 'div').toLowerCase();
		if ( this.state.text ) this.state.text = this.state.text.replace(/#item#/g,`“${this.props.name||'questo item'}”`);
	}

	render() {
		if ( this.state.node === 'hr') return <hr />;
		if ( ! this.state.text ) return '';
		switch (this.state.node) {
			case 'h1':
				return <h1>{this.state.text}</h1>;
			case 'h2':
				return <h2>{this.state.text}</h2>;
			case 'h3':
				return <h3>{this.state.text}</h3>;
			case 'h4':
				return <h4>{this.state.text}</h4>;
			case 'h5':
				return <h5>{this.state.text}</h5>;
			case 'h6':
				return <h6>{this.state.text}</h6>;
			case 'p':
				return <p>{this.state.text}</p>;
			case 'label':
				return <Label>{this.state.text}</Label>;
			default:
				return <div>{this.state.text}</div>;
		}
	}
}

const AutoAbstractField = class extends React.Component {
	constructor(props) {
		super(props);
		/** @type {AutoFormFieldHelperObject } */
		const fh = props.formHelper.fieldHelper( props.def.key || props.index);
		this.state = {
			fh: fh,
			value: fh.getValue() || '',
			hidden: fh.hidden(),
			readonly: fh.readonly(),
			missing: fh.missing()
		}
		if ( props.def.label ) {
			this.state.label = props.def.label.replace(/#item#/g,`“${this.props.topHelper.getValue('name')}”`);
		}
		const classes = [prefix, 'type_'+(props.def?.type||'text')];
		if ( props.def.className ) classes.push(props.def.className);
		if ( props.def.indent ) classes.push("indent indent"+props.def.indent);
		this.state.className = classes.join(" ");
		this.uid = G.generateUid(prefix);
		this.setValue = this.setValue.bind(this);
		this.renderHeader = this.renderHeader.bind(this);
		this.renderLabel = this.renderLabel.bind(this);
		this.renderField = this.renderField.bind(this);
		this.renderFooter = this.renderFooter.bind(this);
	}

	componentDidMount() {
		this.state.fh.notify( (fn) => {
			this.setState(fn);
		});
	}

	componentWillUnmount() {
		G.deregister(this.uid);
	}

	setValue(value) {
		this.state.fh.setValue(value);
	}

	renderHeader() {
		return <Snippet node={this.props.def.header} name={this.props.topHelper.getValue('name')} />;
	}

	renderLabel( missing ) {
		return <Snippet node={{node: (missing ? 'h6' : 'label'), text: this.state.label}} name={this.props.topHelper.getValue('name')} />;
	}

	renderField() {
		return(
			<div>
				Unsupported field type: { this.props.def.type || 'Unknown' }
			</div>
		)
	}

	renderFooter() {
		return <Snippet node={this.props.def.footer} name={this.props.topHelper.getValue('name')} />;
	}

	render() {
		let c = this.state.className;
		if ( this.state.hidden ) c += ' hidden';
		if ( this.state.readonly ) c += ' readonly';
		return(
			<div className={c} id={this.uid}>
				<div className={prefix+"Header"}>
					{ this.renderHeader() }
				</div>
				<div className={prefix+"Label"} key={this.state.missing}>
					{ this.renderLabel(this.state.missing) }
				</div>
				<div className={prefix+"Control"}>
					{ this.renderField() }
				</div>
				<div className={prefix+"Footer"}>
					{ this.renderFooter() }
				</div>
			</div>
		)
	}
}

export default AutoAbstractField;